import { createGlobalStyle } from 'styled-components';

export const ThemeTokensStyle = createGlobalStyle`
  :root {
    --ln-surface: 34 37 69;
    --ln-surface-raised: 51 58 91;
    --ln-surface-control: 68 76 112;
    --ln-surface-muted: 36 42 72;
    --ln-surface-nav: 13 21 51;
    --ln-surface-sunken: 3 11 40;
    --ln-content: 255 255 255;
    --ln-overlay: 255 255 255;
    --ln-tab-active: 97 222 255;
    --ln-accent: 225 255 106;
    --ln-accent-ink: 225 255 106;
    --ln-surface-deep: 3 11 40;
    --ln-red-ink: 248 113 113;
    --ln-content-muted: #A5AAC5;
    --ln-content-subtle: #A7AAB6;
    --ln-edge-muted: #A5AAC5;
    --ln-ink-mint: 97 255 217;
    --ln-ink-amber: 255 199 0;
    --ln-ink-negative: 255 159 106;
    --ln-surface-panel: 3 11 40;
    --ln-surface-strip: 3 11 40;
    --ln-surface-banner: 68 76 112;
    --ln-surface-chip: 3 11 40;
    --ln-surface-tag: 13 21 51;
    --ln-track: #0D1533;
    --ln-surface-row: 36 42 72;
    --ln-surface-recess: #030B28;
    --ln-surface-quiet: 3 11 40;
    --ln-filter-box: #030B28;
    --ln-board-arrow-bg: rgba(2, 11, 42, 0.5);
    --ln-board-arrow-ink: var(--ln-content-subtle);
    --ln-course-metric-icon: #FFFFFF;
    --ln-tile-edge: transparent;
    --ln-ring-track: #0D1335;
    --ln-cta-primary: 225 255 106;
    --ln-cta-join: 225 255 106;
    --ln-cta-join-text: 11 20 32;
    --ln-cta-join-text-alt: 45 45 58;
    --ln-badge-bg: 225 255 106;
    --ln-badge-active-ink: 225 255 106;
    --ln-teacher-pill: 51 58 83;
    --ln-teacher-pill-hover: 86 91 112;
    --ln-shadow-card: 0 1px 2px rgb(3 11 40 / 0.3), 0 4px 12px rgb(3 11 40 / 0.24);
    --ln-shadow-card-hover: 0 2px 5px rgb(3 11 40 / 0.36), 0 8px 20px rgb(3 11 40 / 0.3);
    --ln-text-sub: #989BAD;
    --ln-text-error: #FF5151;
    --ln-tab-ink: #9FAABA;
    --ln-tab-ink-active: #61DEFF;
    --ln-tab-edge: #444C70;
    --ln-tab-edge-soft: #3A3A4A;
    --ln-menu-hover: #EAEAF1;
    --ln-tone-orange: 254 171 45;
    --ln-tone-lime: 172 204 81;
    --ln-tone-pink: 240 74 156;
    --ln-ink-on-dark: #fbfcff;
    --ln-badge-count-bg: #61DEFF;
    --ln-badge-count-ink: #0B0B0B;
    --ln-text-absent: #FF606B;
    --ln-icon-ink: #FBFCFF;
    --ln-label-muted: #5d627c;
    --ln-track-inset: #0D1533;
    --ln-loader-from: #0D1533;
    --ln-text-highlight: #FFFD83;
    --ln-icon-muted: #A3A6AB;

    --toggle-switch-active-background: linear-gradient(95.74deg, #00bce8 0.64%, #0082b2 99.16%), #0082b2;
    --toggle-switch-ball-background: linear-gradient(180deg, var(--color-white) 0%, rgba(255, 255, 255, 0.88) 100%);
    --form-error-color: #ff5858;
    --color-blue-ink: #61deff;
  }

  :root[data-theme='light'] {
    --ln-surface: 246 247 251;
    --ln-surface-raised: 255 255 255;
    --ln-surface-control: 255 255 255;
    --ln-surface-muted: 246 246 250;
    --ln-surface-nav: 246 247 251;
    --ln-surface-sunken: 239 241 246;
    --ln-content: 11 20 32;
    --ln-overlay: 3 11 40;
    --ln-tab-active: 11 20 32;
    --ln-accent: 223 8 94;
    --ln-accent-ink: 190 7 80;
    --ln-surface-deep: 215 215 226;
    --ln-red-ink: 168 30 30;
    --ln-content-muted: rgb(11 20 32 / 0.7);
    --ln-content-subtle: rgb(11 20 32 / 0.6);
    --ln-edge-muted: rgb(11 20 32 / 0.4);
    --ln-ink-mint: 0 116 95;
    --ln-ink-amber: 143 106 0;
    --ln-ink-negative: 181 71 8;
    --ln-surface-panel: 255 255 255;
    --ln-surface-strip: 200 206 216;
    --ln-surface-banner: 208 212 224;
    --ln-surface-chip: 225 228 242;
    --ln-surface-tag: 225 228 242;
    --ln-track: #EDEFF7;
    --ln-surface-row: 237 239 247;
    --ln-surface-recess: #EDEFF7;
    --ln-surface-quiet: 246 247 251;
    --ln-filter-box: rgba(0, 0, 0, 0.1);
    --ln-board-arrow-bg: rgb(215 215 226);
    --ln-course-metric-icon: #0B1420;
    --ln-tile-edge: rgb(11 20 32 / 0.08);
    --ln-ring-track: #D3D7E6;
    --ln-cta-primary: 97 222 255;
    --ln-cta-join: 223 8 94;
    --ln-cta-join-text: 255 255 255;
    --ln-cta-join-text-alt: 255 255 255;
    --ln-badge-bg: 97 222 255;
    --ln-badge-active-ink: 255 255 255;
    --ln-teacher-pill: 229 231 234;
    --ln-teacher-pill-hover: 216 218 222;
    --ln-shadow-card: 0 1px 2px rgb(11 20 32 / 0.06), 0 4px 12px rgb(11 20 32 / 0.05);
    --ln-shadow-card-hover: 0 2px 6px rgb(11 20 32 / 0.09), 0 10px 24px rgb(11 20 32 / 0.08);
    --ln-text-sub: rgb(11 20 32 / 0.7);
    --ln-text-error: rgb(168 30 30);
    --ln-tab-ink: rgb(11 20 32 / 0.6);
    --ln-tab-ink-active: rgb(11 20 32);
    --ln-tab-edge: rgb(3 11 40 / 0.25);
    --ln-tab-edge-soft: rgb(3 11 40 / 0.1);
    --ln-tone-orange: 143 86 0;
    --ln-tone-lime: 79 106 0;
    --ln-tone-pink: 184 21 106;
    --ln-text-absent: rgb(181 71 8);
    --ln-icon-ink: rgb(11 20 32);
    --ln-label-muted: #63677a;
    --ln-track-inset: rgb(3 11 40 / 0.1);
    --ln-loader-from: #e1e7f3;
    --ln-text-highlight: rgb(223 8 94);
    --ln-icon-muted: rgb(11 20 32 / 0.6);

    --form-error-color: #ca1e2c;
    --color-blue-ink: #006987;
    --toggle-switch-ball-background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.94) 100%);

    * {
      scrollbar-color: rgb(var(--ln-overlay) / 0.3) rgb(var(--ln-surface-sunken));
    }

    *::-webkit-scrollbar-track {
      background: rgb(var(--ln-surface-sunken));
    }

    *::-webkit-scrollbar-thumb {
      background: rgb(var(--ln-overlay) / 0.3);
    }

    *::-webkit-scrollbar-thumb:hover {
      background: rgb(var(--ln-overlay) / 0.4);
    }

    *::-webkit-scrollbar-thumb:active {
      background: rgb(var(--ln-overlay) / 0.5);
    }
  }
`;
